export const formFilter = [
    {
        input: { id: 'marca', label: 'Marca', placeholder: 'Digite a marca' },
        layout: { type: 'col', layout: { base: 12, md: 3 } }
    },
    {
        input: { id: 'modelo', label: 'Modelo', placeholder: 'Digite o modelo' },
        layout: { type: 'col', layout: { base: 12, md: 3 } }
    },
    {
        select: {
            id: 'ativo',
            label: 'Ativo?',
            options: [
                {
                    value: true,
                    text: 'Sim'
                },
                {
                    value: false,
                    text: 'Não'
                }
            ]
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    }
];